(function ($) {
    var break_point = 768;
    var browser_width = window.innerWidth;
    var scroll = $(window).scrollTop();
    var inpagenav = $('.sticky');

    if (inpagenav.length) {
        var inpagenavTop = inpagenav.offset().top;

        if (browser_width < break_point) {
            function stick(scroll) {
                if (scroll >= inpagenavTop) {
                    inpagenav.addClass('stuck')
                }
                if (scroll < inpagenavTop) {
                    inpagenav.removeClass('stuck')
                }
            }
            $(window).scroll(function () {
                scroll = $(window).scrollTop();
                stick(scroll);
            });
            stick(scroll);
        }
    }

})(jQuery);